import { User } from '@/models/user'
import type {
  ICustomer,
  ICustomerData,
  ICustomerProfile,
  ICustomerProfileData
} from './customer.types'
import { PermissionGroup, type IPermissionGroup } from '../permission'
import { CustomerSiteAssignment, type ICustomerSiteAssignment } from '../site-management'
import { AbstractModel } from '../base'

/**
 * A class representing an CustomerProfile.
 */
export class CustomerProfile extends AbstractModel implements ICustomerProfile {
  readonly id?: number
  readonly title: string
  readonly site_assignments: ICustomerSiteAssignment[] = []

  constructor(data: ICustomerProfileData) {
    super()

    // Validate data
    const requiredFields: (keyof ICustomerProfileData)[] = ['title']
    this.validate(data, requiredFields)

    if (data.id) {
      this.id = data.id
    }

    this.title = data.title!

    if (data.site_assignments) {
      this.site_assignments = data.site_assignments.map(
        (assignment) => new CustomerSiteAssignment(assignment)
      )
    }
  }
}

/**
 * A class representing a Customer.
 */
export class Customer extends User implements ICustomer {
  readonly profile: ICustomerProfile
  readonly groups?: (number | IPermissionGroup)[]

  constructor(data: ICustomerData) {
    super(data)

    if (data.profile == null || typeof data.profile !== 'object') {
      this.validate(data, ['profile' as keyof ICustomerData])
    }
    this.profile = new CustomerProfile(data.profile!)

    if (data.groups) {
      this.groups = data.groups.map((group) => {
        return typeof group !== 'number' ? new PermissionGroup(group) : group
      })
    }
  }
}
